export const shouldRenderButton = ({
  customerAccess,
  isInStock,
  oosVariantsAreSelectable,
}) => {
  return !customerAccess && oosVariantsAreSelectable && isInStock !== null;
};
